import {
  base_colorAction,
  base_colorAlert,
  base_colorContentBorder,
  base_colorRaisedSurface,
  base_colorSurfaceSecondary,
  base_contentHover,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  &.SavedViewsDropdown {
    display: flex;
    flex-direction: column;
    position: absolute;
    z-index: 5;
    padding-bottom: ${spacing(2)};

    & .container {
      display: flex;
      flex-direction: column;
      box-shadow: 0 4px 10px 0 rgba(25, 16, 16, 0.1);
      background-color: ${base_colorRaisedSurface};
      border: 1px solid ${base_colorAction};
      border-radius: ${spacing(2)};
      overflow: hidden;
      width: 300px;
      height: auto;
    }

    .options {
      max-height: 300px;
      overflow-y: auto;
    }

    .option-title {
      display: flex;
      flex-direction: column;
      padding: ${spacing(3)} ${spacing(4)};
    }

    .option {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      padding: ${spacing(3)} ${spacing(4)};

      &.active {
        background-color: ${base_contentHover};
      }

      &:hover,
      &:focus,
      &[aria-selected='true'] {
        background-color: ${base_contentHover};
        outline: none;
      }

      .delete-button {
        opacity: 0;
        transition: opacity 0.2s ease;
        svg > g {
          fill: ${text_colorTextSecondary};
        }
        :hover {
          svg > g {
            fill: ${base_colorAlert};
          }
        }
      }

      &:hover .delete-button,
      &:focus .delete-button,
      .delete-button:focus {
        opacity: 1;
      }
    }

    .save-container {
      background: ${base_colorSurfaceSecondary};
      padding: ${spacing(2)};
      border-top: 1px solid ${base_colorContentBorder};
    }

    .save-button {
      padding: ${spacing(2)};
    }
  }
`
